import { eDateFilterType } from '../../providers/ModalsProvider/Modals.types';
import { tAdvanceSearchModalContext } from './AdvanceSearchModal.types';

export const initialState: tAdvanceSearchModalContext = {
  leads: [],
  loading: false,
  inputValue: '',
  isLastPage: false,
  totalLeads: 0,
  stateFilters: null,
  assignedUserFilters: null,
  funnelForFilters: null,
  stageForFilters: null,
  channelFilter: null,
  funnels: null,
  dateRange: [undefined, undefined],
  dateFilterType: eDateFilterType.CREATED_AT,
  stages: [],
  loadingStages: false,
  areFiltersActive: false,
  activeFilterCount: 0,
  setStages: () => {},
  setDateRange: () => {},
  setDateFilterType: () => {},
  setStageForFilters: () => {},
  setFunnelForFilters: () => {},
  setAssignedUserFilters: () => {},
  setStateFilters: () => {},
  setChannelFilter: () => {},
  setLoading: () => {},
  setInputValue: () => {},
  setLeads: () => {},
  getMoreLeads: async () => {},
  resetFilters: () => {},
  setLastFilters: () => {},
  saveFiltersInLocalStorage: () => {},
  getStages: async () => {},
};

export { integrationIcons } from 'src/constants/channel.constants';
